export default class HttpStatusError extends Error {
  constructor(_message) {
    super(_message);
    this.name = "HttpStatusError";
  }
}
